import {getTokenKey} from 'helpers/localStorage'
import {watchAsyncData} from 'modules/asyncCache/sagas'
import {all, fork, put} from 'redux-saga/effects'
import Auth from './auth/sagas'

// ─── Danh sách prefix route public (không cần auth) ──────────────────────────
const PUBLIC_ROUTE_PREFIXES = [
  '/church/',
  // thêm route public khác vào đây
]

const isPublicRoute = (pathname) =>
    PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))

// ─── initialApp: chỉ gọi LOGIN khi cần ───────────────────────────────────────
function* initialApp() {
  if (!getTokenKey()) return           // không có token → bỏ qua

  const pathname = window.location.pathname
  if (isPublicRoute(pathname)) return  // route public → bỏ qua, không gọi API

  yield put({ type: 'LOGIN' })
}

function* rootSagas() {
  yield all([
    ...Auth,
    fork(watchAsyncData),
    fork(initialApp)
  ])
}

export default rootSagas